export default {
  header: {
    title: '¡Genial! Obtienes lo siguiente gratis con tu pedido:',
    subtitle: 'Aplicaremos el descuento durante el proceso de pago.',
  },
  footer: {
    buttons: {
      no_thanks: 'No, gracias',
      add_to_basket: 'Añadir al carrito',
    },
  },
};
